export default __webpack_public_path__ + "static/media/Asset 9.b5062b8e.svg";